import { api } from "@/client/api";
import { configs } from "@/configs";

import type { PermissionDoor } from "@/models";

type UpdatePermissionDoorInput = {
  branchId: string;
  id: number;
  doorIds: number[];
};

export async function getPermissionDoors(branchId: string) {
  const { data } = await api.get<PermissionDoor[]>(
    `${configs.apiUrl}/commander/branches/${branchId}/permission-doors`
  );
  return data;
}

export async function updatePermissionDoor({
  branchId,
  id,
  ...data
}: UpdatePermissionDoorInput) {
  return await api.put(
    `${configs.apiUrl}/commander/branches/${branchId}/permission-doors/${id}`,
    data
  );
}
